module.exports = __webpack_public_path__ + "static/img/scenes_icon_recommend.3586b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenes_icon_recommend.png
// module id = e8lw
// module chunks = 1